export const buildDate: string = "2026-04-22 14:14:19";
export const appState:number = 1;
